import { observable } from 'mobx'

export const PollConfig = observable({ globalEnabled: true })
